module.exports = __webpack_public_path__ + "e87aefa4e9a0fef62c5f1fca7334ff84.png";